export default __webpack_public_path__ + "static/media/bear-red.05adeb7f.svg";